import CountCell from 'components/CountCell';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function TeamsCountCell({ rowData: { id, totals } }: CellProps) {
  return (
    <CountCell
      count={totals?.sentinelTeams}
      sectionPath={ROUTE_NAMES.admin.managementTeams}
      pageParams={{
        oemSegmentIds: [id],
        teamIds: [],
        accountIds: [],
        depotIds: [],
      }}
    />
  );
}
